var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success",
    fill: "#D5DAE3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M30.65,11.55 C30.35,11.25 29.85,11.25 29.55,11.55 L17.4,23.8 C17.2,24 16.85,24 16.65,23.8 L10.45,17.55 C10.15,17.25 9.65,17.25 9.35,17.55 L8.25,18.65 C7.95,18.95 7.95,19.45 8.25,19.75 L16.5,28.05 C16.8,28.4 17.3,28.4 17.6,28.05 L31.75,13.75 C32.05,13.45 32.05,12.95 31.75,12.65 L30.65,11.55 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.80af6985cb8e3d5123af0eb9cdcb2d9a.svg";
export { ForwardRef as ReactComponent };